export const contactUS = {
    title: 'ติดต่อเรา',
    address: 'ที่อยู่',
    email: 'อีเมล์',
    mobile_number: 'เบอร์ติดต่อ',
    contact_detail: 'สามารถติดต่อได้ในเวลาทำการ จันทร์-อาทิตย์ เวลา 09.00 - 17.30 ยกเว้นวันหยุดนักขัตฤกษ์'
}
